import React from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router";

// Children own their layout (TopBar + content card) to avoid double-wrapping.
function ExpenseType() {
  return (
     <Box sx={{width:"100%"}}>
        <Outlet/>
     </Box>
  );
}

export default ExpenseType;
